/* eslint-disable react-hooks/exhaustive-deps */
import { LoaderFunction, MetaFunction } from "react-router";
import { parse } from "cookie";
import { useEffect } from "react";
import QuizHome from "~/components/satsang-quiz/QuizHome";
import BreadCrubComponent from "~/components/shared-components/BreadCrubComponent";
import { getPageMeta } from "~/lib/helperFuncation/metaHelper";
import { removeSession } from "~/lib/helperFuncation/sessionStorageService";
import {
  getSatsangQuizDataThunk,
  getUpcomingQuizDataThunk,
  getUserStatsDataThunk,
  setCurrentQuestion,
  setTotalPoints,
} from "~/lib/store/slice/satsangQuizSlice";
import { useAppDispatch } from "~/lib/store/store";
import { AUTH_COOKIE_TOKEN, FALLBACK_IMAGE_URL, LANG, QUIZ_COMPLETED, QUIZ_SESSION_KEY } from "~/utils/constant";
import { getCookie } from "~/utils/cookies";
import { homeRouteString } from "~/utils/helper-funcations";
import { metaService } from "~/utils/metaService";

export const loader: LoaderFunction = async ({ request, params }) => {
  const cookieHeader = request.headers.get("Cookie") || "";
  const cookies = parse(cookieHeader);
  const lang = params.lang || LANG.english;

  const token = cookies[AUTH_COOKIE_TOKEN] || null;

  return Response.json({
    token,
    title: lang === LANG.english ? "Satsang Quiz" : "સત્સંગ ક્વિઝ",
  });
};

export const handle = {
  breadcrumb: (match: any) => {
    const lang = match.params.lang;
    return (
      <BreadCrubComponent
        breadCrub={[
          {
            path: homeRouteString(lang).path,
            title: homeRouteString(lang).home,
          },
        ]}
      />
    );
  },
  breadcrumbSchema: (match: any) => [
    { name: "Home", path: "/" },
    { name: match.data?.title || "Satsang Quiz", path: "/satsang-quiz" },
  ],
};

export const meta: MetaFunction = ({ location, params }) => {
  const pathname = location?.pathname || "/";
  const lang = params.lang || "en";

  const meta = getPageMeta("satsangQuiz", lang);

  return metaService({
    title: meta.metaTitle,
    description: meta.metaDescription,
    ogTitle: meta.ogTitle,
    ogDescription: meta.ogDescription,
    ogUrl: pathname,
    ogImg: meta.ogImage || FALLBACK_IMAGE_URL,
    ogWidth: meta.ogImageWidth || "1200",
    ogHeight: meta.ogImageHeight || "630",
    canonicalLink: pathname,
    hreflangs: [
      { hrefLang: "x-default", href: `${pathname}` },
      { hrefLang: "en", href: `${pathname}` },
      { hrefLang: "gu", href: `${pathname}` },
    ],
  });
};

function SatsangQuiz() {
  const dispatch = useAppDispatch();
  const token = getCookie(AUTH_COOKIE_TOKEN);
  let timeout: NodeJS.Timeout;

  // Effect for initial data loading
  useEffect(() => {
    dispatch(getSatsangQuizDataThunk());
    dispatch(getUpcomingQuizDataThunk());
    // dispatch(getCompletedWithAuthQuizDataThunk());

    removeSession(QUIZ_SESSION_KEY);
    removeSession(QUIZ_COMPLETED);
    dispatch(setCurrentQuestion(0));
    dispatch(setTotalPoints(0));

    if (token) {
      timeout = setTimeout(() => {
        dispatch(getUserStatsDataThunk({ mode: "desktop", tempToken: token }));
      }, 2000);
    }

    return () => clearTimeout(timeout);
  }, [dispatch]);

  return (
    <div className="w-full flex items-center justify-center p-4">
      <QuizHome />
    </div>
  );
}

export default SatsangQuiz;
